<template>
  <div class="container-fluid">
    <!--PORTFOLIO HEADER -->
    <h2
      class="text-center fw-bolder display-4 text-uppercase text-dark mb-0"
      id="portfolio"
    >
      Portfolio
    </h2>
    <!--DIVIDER LINE -->
    <div class="divider-custom">
      <div class="divider-custom-line" />
      <div class="divider-custom-icon">
        <i class="fas fa-code fs-1" style="color: #222831"></i>
      </div>
      <div class="divider-custom-line" />
    </div>
    <!--PORTFOLIO CONTENT -->
    <portfolio-body />
  </div>
</template>

<script>
import PortfolioBody from "./PortfolioBody.vue";

export default {
  name: "portfolio-content",
  components: { PortfolioBody },
};
</script>

<style scoped>
h2 {
  margin-top: 5rem;
}

.divider-custom {
  margin: 1.25rem 0 1.5rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.divider-custom .divider-custom-line {
  width: 100%;
  max-width: 10rem;
  height: 0.3rem;
  background-color: #222831;
  border-radius: 1rem;
  border-color: #222831 !important;
}
</style>